module.exports = __webpack_public_path__ + "static/media/Checkmark@3x.6781fdbc.png";